<div class="box_default box_grey add_user">
  <header>
    <h3>Add user to group</h3>
  </header>
    <core-helpers-box-loading *ngIf="status==STATUS_LOADING"></core-helpers-box-loading>
    <div *ngIf="status==STATUS_DONE"  class="box_main">
      <div class="box_item">
        <core-helpers-forms-select
            [placeholder]="'Select an user for add to group'"
            [label]="'Select user'"
            [options]="users"
            (select)="select($event)"
        ></core-helpers-forms-select>
      </div>
        <div class="box_fieldset">
            <core-helpers-forms-button-white [disabled]="selectedUser==null" [text]="'Save'" (click)= "onSubmit()"></core-helpers-forms-button-white>
            <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
        </div>

    </div>

    <!-- <ul *ngIf="status==STATUS_DONE">
        <settings-groups-group-users-add-form
            [existingUsers]="users"
        ></settings-groups-group-users-add-form>

        <li *ngFor="let user of users">
            <span>{{user.name}}</span> <a (click)="remove(user)">Remove</a>
        </li>
    </ul> -->
</div>
